<div matRipple class="custom-chip" [style.backgroundColor]="backgroundColor" [style.color]="textColor">
    <span *ngIf="icon" class="material-icons" style="font-size: 1.1rem; margin-right: .5rem;">{{ icon }}</span>
    <span class="text" *ngIf="titleCase">{{ text | titlecase }}</span>
    <span class="text" *ngIf="!titleCase">{{ text }}</span>
</div>